import React, { useState, useEffect, useRef } from 'react'
import { Timeline, Steps, Loader } from 'rsuite'
import {
  Container, FlexH, TitleDiv, EventState, H1, BodyDiv,
  DescriptionDiv, MyStepItem, MyTimelineItem, Duration, Timer, StepsTitle
} from '../Components/Event/EventStyledComponents'
import Overview from '../Components/EventParticipantView/Overview'
// import Stepper from '../Components/EventParticipantView/Stepper'
import { useParams, Link } from 'react-router-dom'
import firebase from 'firebase/app'
import styled from 'styled-components'
import { colors } from '../Components/Styles/common-styles'
import '../Components/Styles/navigation-bar.css'

const Background = styled.div`
    height: 100%;
    color: ${colors.purpleMain}
`

const NotFound = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 560px;
    height: 506px;
    background: ${colors.white};
    border-radius: 8px;
`

const StatusCode = styled.div`
    font-size: 144px;
    font-weight: 600;
    line-height: 183px;
    letter-spacing: 4px;
    color: ${colors.grey}
`

const StatusText = styled.div`
    font-size: 36px;
    font-weight: 400;
    line-height: 46px;
    letter-spacing: 0px;
    color: ${colors.black}
`

const EventIsNotStarted = () => (
  <Background>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex' }}>
        <Link to='/'>
          <div className='brand-name'>
            <span className='taito'>TAITO</span>
            <span className='training'>TRAINING</span>
          </div>
        </Link>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <NotFound>
          <StatusCode>Sorry</StatusCode>
          <StatusText>Event is not started.</StatusText>
        </NotFound>
      </div>
    </div>
  </Background>
)

const TimelineItem = (props) => {
  const {
    currentPhase, currentActivity, event
  } = props
  const phase = event.phases[currentPhase]

  return (
    <Timeline>
      {event !== null &&
        phase.data.map((activity, index) => {
          return (
            <MyTimelineItem
              key={index}
              current={currentActivity === index ? 1 : 0}
              done={activity.isCompleted ? 1 : 0}
            >
              {!activity.topic ? activity.title[0].text : activity.topic}
            </MyTimelineItem>
          )
        }
        )}
    </Timeline>
  )
}

const EventPage = () => {
  const [isOverview, setOverview] = useState(true) // shows component before starting a new activity
  const [seconds, setSeconds] = useState(0) // seconds for the timer
  // const [isTimerActive, setTimerActive] = useState(true) // minutes for the timer
  const [curPhase, setCurPhase] = useState(0) // current phase
  const [curActivity, setCurActivity] = useState(0) // current activity
  const [curStep, setCurStep] = useState(0) // current step
  const [isEventFinished, setEventFinished] = useState(false) // for now shows component after clicking 'Mark as completed' on the last activity
  const [eventIsNotStarted, setEventIsNotStarted] = useState(false)
  const [hasInstructions, setHasInstructions] = useState(false)

  const [loading, setLoading] = useState(true)
  const [event, setEvent] = useState(null)
  const { eventId } = useParams()

  const db = firebase.firestore()

  useEffect(async () => {
    const update = snapshot => {
      if (snapshot && snapshot.timestamp >= Date.now() - 1000 * 60 * 60) {
        setCurPhase(snapshot.currentPhase)
        setCurActivity(snapshot.currentActivity)
        setCurStep(snapshot.currentStep)
        setOverview(snapshot.overview)
        setEventFinished(snapshot.isEventFinished)
        setSeconds(snapshot.seconds)
        setEvent(snapshot.finished)
        setLoading(false)
        setEventIsNotStarted(false)
        setHasInstructions(snapshot.hasInstructions)
      } else if (snapshot.timestamp < Date.now() - 1000 * 60 * 60) {
        setEventIsNotStarted(true)
        setLoading(false)
      } else {
        setEventIsNotStarted(false)
        setLoading(true)
      }
    }
    const document = db.collection('events').doc(eventId)
    const doc = await document.get()
    if (!doc.exists) {
      setEventIsNotStarted(true)
      setLoading(false)
      return
    }
    update(doc.data().snapshot)
    const unsubscribe = document.onSnapshot(doc => update(doc.data().snapshot))
    return unsubscribe
  }, [])

  console.log(seconds)

  return (
    <Container>
      {eventIsNotStarted
        ? <EventIsNotStarted />
        : loading
          ? <Loader backdrop size='lg' content='loading...' vertical />
          : <div>
            <TitleDiv>
              <H1>{event?.title}</H1>
              <FlexH>
                <EventState>{curPhase + 1}/{event?.phases?.length} phases</EventState>
                <EventState>{curActivity + 1}/{event?.phases[curPhase]?.data?.length} activities</EventState>
              </FlexH>
            </TitleDiv>

            <BodyDiv>
              <div>
                <Steps current={0} vertical>
                  {event?.phases !== null &&
                  event?.phases.map((phase, index) => (
                    <MyStepItem
                      title={phase?.name}
                      key={index}
                      current={curPhase === index ? 1 : 0}
                      done={phase?.isCompleted ? 1 : 0}
                      //   onClick={() => onPhaseClick(index)}
                      description={index === curPhase
                        ? <TimelineItem
                          currentPhase={curPhase}
                          setOverview={setOverview}
                          currentActivity={curActivity}
                          event={event}
                        />
                        : ''}
                    />
                  ))}
                </Steps>
              </div>

              <div>
                <DescriptionDiv>
                  <div style={{ padding: '30px 26px' }}>
                    {!isOverview && hasInstructions
                      ? <Instructions
                        seconds={seconds}
                        curPhase={curPhase}
                        curActivity={curActivity}
                        setOverview={setOverview}
                        event={event}
                      />
                      : <Overview
                        isEventFinished={isEventFinished}
                        setEventFinished={setEventFinished}
                        currentPhase={curPhase}
                        currentActivity={curActivity}
                        currentStep={curStep}
                        setCurrentStep={setCurStep}
                        setCurrentPhase={setCurPhase}
                        setCurrentActivity={setCurActivity}
                        phasesData={event}
                        phasesLength={event?.phases?.length - 1}
                        isOverview={isOverview}
                        setOverview={setOverview}
                        event={event}
                      />}
                  </div>
                </DescriptionDiv>
              </div>
            </BodyDiv>
          </div>}
    </Container>
  )
}

const Instructions = ({ event, curPhase, curActivity, seconds }) => {
  const instructionRef = useRef(null)
  const phase = event?.phases[curPhase] || null
  const activity = phase?.data[curActivity] || null
  const durationMin = activity?.duration_min || '?'
  const durationMax = activity?.duration_max || '?'
  console.log(durationMax)
  console.log(seconds)

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Duration>{durationMin} - {durationMax} min </Duration>
        <Timer>
          {parseInt(seconds / 60) < 10 ? '0' + parseInt(seconds / 60) : parseInt(seconds / 60)}
          &#8203;
          : {seconds % 60 < 10 ? '0' + seconds % 60 : seconds % 60}
        </Timer>
      </div>
      <div ref={instructionRef}>
        <StepsTitle>INSTRUCTIONS</StepsTitle>
        <div style={{ margin: '30px 0' }}>{activity.instructions}</div>
      </div>
    </>
  )
}

export default EventPage
